import { PoUploadFileLogField } from "@saleor/graphql";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getPoUploadtFilterTable(
  sort: PoUploadFileLogField
): PoUploadFileLogField {
  switch (sort) {
    case PoUploadFileLogField.UPDATED_AT:
      return PoUploadFileLogField.UPDATED_AT;
    default:
      return undefined;
  }
}

export const getSortPoUploadFilterTable = createGetSortQueryVariables(
  getPoUploadtFilterTable
);
